module.exports = __webpack_public_path__ + "img/dsci0088.4405ba5c.jpg";